import type { ReactNode } from 'react'
import React from 'react'
import { Text, csx, cx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

export type ChangeShippingMethodDrawerTitleProps = {
  children: ReactNode
  className?: string
}

export const ChangeShippingMethodDrawerTitle = ({
  children,
  className = '',
}: ChangeShippingMethodDrawerTitleProps) => (
  <>
    <Text variant="detail" className={cx(className)}>
      <FormattedMessage id="checkout.shipping.select-shipping-method.changeDeliveryMethod" />
    </Text>
    <Text
      variant="title1"
      className={csx({
        display: 'block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      })}
    >
      {children}
    </Text>
  </>
)
